import React from 'react';
import {
  Box,
  FormControlLabel,
  Checkbox,
  Typography,
  FormControl,
  Select,
  MenuItem,
} from '@mui/material';
import TimePicker from 'react-time-picker';

const TimeOfCollectionBehaviorSection = ({
  dataPoint,
  index,
  handleCheckboxChange,
  handleFieldChange,
  handleTimeChange,
  quicktrackInfo,
  shouldShowOption,
}) => {
  if (!shouldShowOption('Add Time of Collection')) {
    return null;
  }

  return (
    <>
      <FormControlLabel
        control={
          <Checkbox
            checked={dataPoint.selectedOptions.includes(
              'Add Time of Collection'
            )}
            onChange={(e) => handleCheckboxChange(index, e)}
            value='Add Time of Collection'
          />
        }
        label='Add Time of Collection'
      />
      {dataPoint.selectedOptions.includes('Add Time of Collection') && (
        <Box sx={{ ml: 3, pl: 2, borderLeft: '2px solid #e0e0e0' }}>
          {quicktrackInfo?.DataEntrySelection?.TimeOfCollectionType ===
          'specific' ? (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <Typography variant='body1'>Time of Collection:</Typography>
              <FormControl sx={{ minWidth: 300, width: '70%' }}>
                <Select
                  value={dataPoint.timeOfCollectionSpecific || ''}
                  onChange={(event) => {
                    const value = event.target.value;
                    handleFieldChange(
                      index,
                      'timeOfCollectionSpecific',
                      value
                    );
                  }}
                  displayEmpty
                  margin='dense'
                  className='input-height'
                  sx={{ backgroundColor: 'var(--clr-mindly-white)' }}
                >
                  <MenuItem value=''>Select time period</MenuItem>
                  {(
                    quicktrackInfo?.DataEntrySelection
                      ?.TimeOfCollectionSpecificsList || []
                  ).map((period) => (
                    <MenuItem key={period} value={period}>
                      {period}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          ) : (
            <TimePicker
              onChange={(newTime) => handleTimeChange(index, newTime)}
              value={dataPoint.timeOfCollection || ''}
              disableClock={true}
              format='hh:mm a'
              style={{
                maxWidth: '150px',
                height: '70px',
                fontSize: '18px',
                padding: '10px',
              }}
            />
          )}
        </Box>
      )}
    </>
  );
};

export default TimeOfCollectionBehaviorSection;
